/**
 * `ThinkingMessage` — animated indicator shown below the transcript while
 * Flint is between turns (before the first token, or between agent steps).
 *
 * Layout: single morphing pulse dot (sky) + shimmer label.
 * The dot pulses (1.2 s scale) and morphs its corners (4 s square↔circle)
 * via CSS keyframes in `styles/index.css` — no framer-motion dep.
 */
export function ThinkingMessage({
  message = "Flint is working on your request…",
}: {
  message?: string;
}) {
  return (
    <div className="flex items-center gap-2.5 py-1 text-sm" role="status" aria-live="polite">
      <span
        className="ai-thinking-pulse inline-block h-2.5 w-2.5 shrink-0 bg-sky-500"
        aria-hidden
      />
      <span className="ai-chat-shimmer font-medium text-muted">{message}</span>
    </div>
  );
}
